export default __webpack_public_path__ + "static/media/team-img-2.0eec987d.webp";